import React, { useState } from "react";
import {
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  Typography,
  Spin,
  Divider,
  Tooltip,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import "../Common/Form.css";
import { getQuestions } from "../../services/feedbackService";
import { debounce } from "../Common/Debounce";
import QuestionAdd from "./QuestionAdd";

const { Text } = Typography;

const DROPDOWN_TYPE = "dropDown";

const FeedbackTemplateForm = (props) => {
  const { initialValues, onSubmit, status, type, setStatus } = props;
  const [isAddQuestionModalVisible, setIsAddQuestionModalVisible] = useState(
    false
  );
  const [questions, setQuestions] = useState([]);
  const [fetching, setFetching] = useState(false);

  const fetchQuestionsHandler = debounce((value) => {
    setFetching(true);
    getQuestions({ question: value })
      .then((response) => {
        const questionList = response.data.questions.filter(question => !question.isArchived);
        const data = questionList.map((question) => {
          const formattedQuestion = {
            label: `${question.question}`,
            value: question._id,
            type: question.type,
          };
          if (question.type === DROPDOWN_TYPE) {
            formattedQuestion.options = question.options;
          }
          return formattedQuestion;
        });
        setQuestions(data);
        setFetching(false);
      })
      .catch((error) => {
        if (error?.response?.data?.message)
          setStatus({ type: "ERROR", message: error.response.data.message });
        else
          setStatus({
            type: "ERROR",
            message: "Getting questions from the backend failed!",
          });
      });
  }, 250);

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 20, offset: 4 },
    },
  };

  const renderDropdownOptions = (options) => {
    return <div>{`Options: ${options.join(', ')}`}</div>
  };

  return (
    <>
      <QuestionAdd
        isOpen={isAddQuestionModalVisible}
        toggle={() => setIsAddQuestionModalVisible(false)}
      />

      <Form
        {...formItemLayout}
        onFinish={onSubmit}
        initialValues={initialValues}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input name!" }]}
        >
          <Input style={{ width: "50%" }} />
        </Form.Item>

        {/* {questionInputs?.map((item, i) => {
        return (
          <Form.List
            label="Questions"
            name="questions"
            rules={[
              {
                validator: async (_, questions) => {
                  if (!questions || questions.length < 2) {
                    return Promise.reject(new Error("At least 2 questions"));
                  }
                },
              },
            ]}
          >*/}
        <Form.Item
          rules={[
            {
              min: 2,
              message: "at least two questions are required",
              type: "array",
              required: true,
            },
          ]}
        >
          <Form.List name="questions">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => (
                  <div
                    key={field.key}
                    style={{ display: "flex", marginBottom: "10px" }}
                  >
                    <Form.Item
                      {...field}
                      {...(index === 0
                        ? formItemLayout
                        : formItemLayoutWithOutLabel)}
                      label={index === 0 ? "Questions" : ""}
                      style={{ margin: "0px", width: "95%" }}
                      fieldKey={[field.fieldKey, "_id"]}
                      rules={[{ required: true, message: "Missing question" }]}
                    >
                      <Select
                        mode={""}
                        placeholder="Search questions"
                        notFoundContent={
                          fetching ? <Spin size="small" /> : null
                        }
                        filterOption={false}
                        showSearch={true}
                        onSearch={fetchQuestionsHandler}
                        dropdownRender={(menu) => (
                          <div>
                            {menu}
                            <Divider style={{ margin: "5px" }} />
                            <p
                              style={{
                                margin: "10px",
                                float: "left",
                                position: "relative",
                              }}
                            >
                              Add new questions
                            </p>
                            <Button
                              type="text"
                              style={{
                                float: "right",
                                position: "relative",
                              }}
                              onClick={() => setIsAddQuestionModalVisible(true)}
                            >
                              +
                            </Button>
                          </div>
                        )}
                      >
                        {questions.map((item, index) => {
                          if (item.type === DROPDOWN_TYPE) {
                            return (
                                <Select.Option value={item.value} key={index}>
                                  <Tooltip title={renderDropdownOptions(item.options)} placement="leftTop">
                                    <div style={{ width: "100%" }}>
                                      <div
                                          style={{
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis"
                                          }}
                                      >
                                        <div>{item.label}</div>
                                        <div>{item.type}</div>
                                      </div>
                                    </div>
                                  </Tooltip>
                                </Select.Option>
                            );
                          }
                          return (
                            <Select.Option value={item.value} key={index}>
                              {item.label} ({item.type})
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <div style={{ width: "5%", margin: "5px" }}>
                      <MinusCircleOutlined onClick={() => remove(field.name)} />
                    </div>
                  </div>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    style={{ position: "fixed", width: "50%" }}
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                  >
                    Add Question
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form.Item>

        {status.type === "ERROR" ? (
          <Text type="danger">{status.message}</Text>
        ) : null}
        {status.type === "SUCCESS" ? (
          <Text type="success">Sucessfully Updated!</Text>
        ) : null}
        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FeedbackTemplateForm;
